import MDBox from "../../components/MDBox";
import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { updateReservationNoteBook } from "../../api/routes";
import Loading from "../../components/Loading";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function UpdateReservationNoteBookModal({ modal, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [information, setInformation] = useState({});
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInformation({ ...information, [name]: value });
  };
  useEffect(() => {
    if (modal?.item) {
      setInformation({
        fullname: modal?.item?.fullname,
        phoneNumber: modal?.item?.phoneNumber,
        description: modal?.item?.description,
      });
    }
  }, [modal?.item]);

  const updateNoteBook = () => {
    setLoading(true);
    let notebookData = {};
    for (let item in information) {
      if (information[item] && information[item] !== modal?.item[item])
        notebookData[item] = information[item];
    }

    updateReservationNoteBook(modal?.item?.id, notebookData, (isOk, data) => {
      setLoading(false);
      if (!isOk) {
        return toast.error(data.message);
      } else {
        toast.success("اطلاعات آپدیت شد!");
        window.location.reload();
      }
    });
  };
  return (
    <Modal
      open={modal.state}
      onClose={handleClose}
    >
      <MDBox sx={style} pt={4} pb={3} px={3}>
        <Loading loading={loading} />
        <MDBox>
          <MDInput type="text" name={"fullname"} value={information.fullname}
                   onChange={handleChange}
                   label="نام و نام خانوادگی" fullWidth />
        </MDBox>
        <MDBox mt={1}>
          <MDInput type="text" name={"phoneNumber"} value={information.phoneNumber}
                   onChange={handleChange}
                   label="شماره موبایل" fullWidth />
        </MDBox>
        <MDBox mt={1}>
          <MDInput type="text" name={"description"} value={information.description}
                   onChange={handleChange}
                   label="توضیحات" fullWidth />
        </MDBox>
        <MDBox mt={4} mb={1}>
          <MDButton onClick={updateNoteBook} variant="gradient" color="info" sx={{ width: "120px" }}>
            ویرایش
          </MDButton>
        </MDBox>
      </MDBox>
    </Modal>
  );
}
